<div class="wrapper" id="wrapper">
    <app-header *ngIf="showSidebar"></app-header>
    <app-sidebar *ngIf="showSidebar" [menuList1]="menuList"></app-sidebar>
    <router-outlet (activate)="menuCheck($event)"></router-outlet>
</div>
